import React from 'react';
import { Badge, Box, HStack, Text } from '@chakra-ui/react';

const PlanBillingToggle = ({ isYearly, onChange, variant = 'hero', size = 'md' }) => {
	const isLight = variant === 'light';
	const isCompact = size === 'sm';

	return (
		<HStack
			spacing={0}
			borderRadius='full'
			overflow='hidden'
			border='2px solid'
			borderColor={isLight ? 'gray.200' : 'whiteAlpha.300'}
			maxW={isCompact ? '240px' : '420px'}
			w={isCompact ? 'auto' : 'full'}
			flexShrink={0}
			position='relative'
			bg={isLight ? 'gray.100' : 'whiteAlpha.100'}>
			<Box
				position='absolute'
				top='2px'
				bottom='2px'
				left={isYearly ? 'calc(50% - 2px)' : '2px'}
				w='calc(50% - 2px)'
				bg='white'
				borderRadius='full'
				transition='left 0.25s ease'
				zIndex={1}
				boxShadow='sm'
			/>
			<Box
				as='button'
				type='button'
				flex={1}
				py={isCompact ? 2 : 3}
				px={isCompact ? 4 : 5}
				color={isYearly ? (isLight ? 'gray.500' : 'whiteAlpha.800') : 'gray.800'}
				fontWeight={isYearly ? '500' : '700'}
				fontSize='sm'
				cursor='pointer'
				position='relative'
				zIndex={2}
				transition='color 0.25s'
				onClick={() => onChange(false)}>
				Monthly
			</Box>
			<Box
				as='button'
				type='button'
				flex={1}
				py={isCompact ? 2 : 3}
				px={isCompact ? 4 : 5}
				color={!isYearly ? (isLight ? 'gray.500' : 'whiteAlpha.800') : 'gray.800'}
				fontWeight={!isYearly ? '500' : '700'}
				fontSize='sm'
				cursor='pointer'
				position='relative'
				zIndex={2}
				transition='color 0.25s'
				onClick={() => onChange(true)}>
				<HStack justify='center' spacing={1}>
					<Text m={0}>Annual</Text>
					<Badge
						colorScheme='green'
						fontSize='9px'
						borderRadius='full'
						px={1.5}
						display={{ base: 'none', sm: 'inline-flex' }}>
						Save
					</Badge>
				</HStack>
			</Box>
		</HStack>
	);
};

export default PlanBillingToggle;
